"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyle = (0, _styles.makeStyles)({
  root: {
    color: _pittaModules.LightColors.primary["4"],
    padding: 3,
    "&.Mui-disabled": {
      color: function color(props) {
        return props.checked ? "".concat(_pittaModules.LightColors.primary["7"], "5A") : "".concat(_pittaModules.LightColors.primary["4"], "5A");
      }
    },
    "&.MuiCheckbox-indeterminate	": {
      color: _pittaModules.LightColors.primary["7"]
    }
  }
});
var CheckBox = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = useStyle(props);
  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
    ref: ref,
    classes: classes
  }, props));
});
exports.CheckBox = CheckBox;